import React, { useEffect } from 'react';

const WhatsAppEmbeddedSignupCallbackPage: React.FC = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');
    const errorMessage = params.get('error_message');
    const errorDescription = params.get('error_description');

    if (window.opener) {
      window.opener.postMessage(
        {
          source: 'gastroflow-whatsapp-oauth',
          code,
          state,
          error: error ? [error, errorMessage, errorDescription].filter(Boolean).join(': ') : '',
        },
        window.location.origin,
      );
      window.close();
    }
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 text-white">
      <div className="max-w-md rounded-[28px] border border-[#2A2A2A] bg-[#101010] p-8 text-center">
        <h1 className="text-2xl font-bold">Conexao com WhatsApp Business</h1>
        <p className="mt-3 text-sm leading-7 text-muted-foreground">
          Finalizando o retorno do Embedded Signup da Meta. Esta janela deve fechar sozinha em alguns segundos.
        </p>
      </div>
    </div>
  );
};

export default WhatsAppEmbeddedSignupCallbackPage;
